export default __webpack_public_path__ + "static/media/mana9.6c89774c.svg";